import INoteContentBuilder from "../Types/INoteContentBuilder";
import NoteTags from "../Types/NoteTags";
import TagSeriesNoteContentBuilder from "../Types/TagSeriesNoteContentBuilder";

const customerNoteTags = [
  NoteTags.serviceSubCategoryName,
  NoteTags.obxTag,
  NoteTags.businessUnitTag,
  NoteTags.customerHeightWeightBmiTag,
  NoteTags.customerDateOfBirthNoteTag,
  NoteTags.customerMedicalQualificationPassFailNoteTag,
  NoteTags.customerDistanceToCenterNoteTag,
  NoteTags.centerNameNoteTag,
  NoteTags.disqualifyingReasonsNoteTag,
  NoteTags.diabetesNoteTag,
  NoteTags.radiationProtectedAreasNoteTag,
  NoteTags.pacemakerWithoutDefibrillatorNoteTag
];

/** The union of props needed to build all tags in {@link CustomerNoteContentBuilder}.
 * @remarks This type looks ugly, but is the only feasible way of building this type organically.
 */
export type CustomerNoteTagProps = typeof customerNoteTags[number] extends {
  buildTagContent: (props: infer P) => unknown;
}
  ? P
  : never;

/** The composed {@link INoteContentBuilder} for building Customer Notes. */
const CustomerNoteContentBuilder: INoteContentBuilder<CustomerNoteTagProps> =
  new TagSeriesNoteContentBuilder<CustomerNoteTagProps>(customerNoteTags, " / ");

export default CustomerNoteContentBuilder;
